import App from './App.svelte';


// Проверка наличия объекта Telegram с выводом детальной информации
function debugTelegramObject() {
  console.log("window объект:", typeof window !== 'undefined');
  console.log("Telegram объект:", window && typeof window.Telegram !== 'undefined');
  
  if (window && window.Telegram) {
    console.log("Telegram.WebApp объект:", typeof window.Telegram.WebApp !== 'undefined');
    
    if (window.Telegram.WebApp) {
      console.log("WebApp свойства:", Object.keys(window.Telegram.WebApp));
      console.log("initData:", window.Telegram.WebApp.initData);
      console.log("initDataUnsafe:", window.Telegram.WebApp.initDataUnsafe);
    }
  }
}

// Попытка получить Telegram WebApp с повторными попытками
function waitForTelegramWebApp(maxAttempts = 5, interval = 200) {
  return new Promise((resolve) => {
    let attempts = 0;
    
    function check() {
      debugTelegramObject();
      
      if (window.Telegram && window.Telegram.WebApp) {
        console.log("Telegram WebApp найден после попытки", attempts + 1);
        resolve(true);
        return;
      }
      
      attempts++;
      if (attempts >= maxAttempts) {
        console.warn(`Telegram WebApp не найден после ${maxAttempts} попыток`);
        resolve(false);
        return;
      }
      
      console.log(`Попытка ${attempts}/${maxAttempts} найти Telegram WebApp...`);
      setTimeout(check, interval);
    }
    
    check();
  });
}

function getTelegramAuthData() {
  try {
    if (!window.Telegram || !window.Telegram.WebApp) return null;
    
    // Возвращаем initData если он есть (это строка с параметрами, включая hash)
    if (window.Telegram.WebApp.initData && window.Telegram.WebApp.initData.length > 0) {
      return window.Telegram.WebApp.initData;
    }
    
    // Если initData пуст, но есть initDataUnsafe, формируем строку с параметрами
    const unsafeData = window.Telegram.WebApp.initDataUnsafe;
    if (unsafeData) {
      const params = new URLSearchParams();
      if (unsafeData.hash) params.append('hash', unsafeData.hash);
      if (unsafeData.user) params.append('user', JSON.stringify(unsafeData.user));
      if (unsafeData.query_id) params.append('query_id', unsafeData.query_id);
      if (unsafeData.auth_date) params.append('auth_date', unsafeData.auth_date);
      
      return params.toString();
    }
    
    return null;
  } catch (e) {
    console.error('Ошибка при получении Telegram Auth Data:', e);
    return null;
  }
}

function initializeTelegramWebApp() {
  try {
    if (!window.Telegram || !window.Telegram.WebApp) {
      console.log('Telegram WebApp объект не найден, запуск в режиме отладки.');
      return false;
    }
    
    // Пробуем вызвать методы с проверкой их существования
    if (typeof window.Telegram.WebApp.ready === 'function') {
      window.Telegram.WebApp.ready();
    }
    
    // Получаем тему
    let tgTheme = 'light';
    if (window.Telegram.WebApp.colorScheme) {
      tgTheme = window.Telegram.WebApp.colorScheme;
    }
    
    document.documentElement.setAttribute('data-theme', tgTheme);
    
    // Расширяем окно если метод доступен
    if (typeof window.Telegram.WebApp.expand === 'function') {
      window.Telegram.WebApp.expand();
    }
    
    if (tgTheme === 'dark') {
      document.body.classList.add('dark-theme');
    }
    
    console.log('Telegram WebApp успешно инициализирован.');
    return true;
  } catch (e) {
    console.error('Ошибка при инициализации Telegram WebApp:', e);
    return false;
  }
}

// Асинхронная инициализация приложения
async function initApp() {

  // Ждем Telegram WebApp
  const isTelegramAvailable = await waitForTelegramWebApp();
  
  // Инициализируем WebApp если доступен
  const isTgEnv = isTelegramAvailable ? initializeTelegramWebApp() : false;
  const authData = isTelegramAvailable ? getTelegramAuthData() : null;
  
  console.log('Инициализация приложения:');
  console.log('- Telegram доступен:', isTelegramAvailable);
  console.log('- WebApp инициализирован:', isTgEnv);
  console.log('- Auth данные:', authData);
  
  const app = new App({
    target: document.body,
    props: {
      isTelegramEnv: isTgEnv,
      authData: authData
    }
  });
  
  return app;
}

// Запускаем инициализацию после полной загрузки DOM
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(() => initApp(), 100);
} else {
  document.addEventListener('DOMContentLoaded', () => setTimeout(() => initApp(), 100));
}

export default { get app() { return appInstance; } };